export default function OverviewSection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-32 px-6 md:px-12">
      <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row gap-16 lg:gap-20">
        <div className="flex-1 lg:max-w-[55%]">
          <p className="text-lg md:text-xl leading-[1.75] text-foreground-900 font-body max-w-[560px]">
            We are a professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. Our approach combines clean architecture, performance optimization, and user-centered design to build systems that scale gracefully and maintain their integrity over time. We emphasize continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions.
          </p>

          <div className="flex gap-20 mt-16">
            <div>
              <p className="text-5xl font-bold font-heading text-foreground-950">Clean</p>
              <p className="text-sm text-foreground-400 font-body mt-2 leading-relaxed">
                Architecture
              </p>
              <p className="text-xs text-foreground-500 font-body mt-1">
                Structured for long-term maintainability
              </p>
            </div>
            <div>
              <p className="text-5xl font-bold font-heading text-foreground-950">Fast</p>
              <p className="text-sm text-foreground-400 font-body mt-2 leading-relaxed">
                Performance
              </p>
              <p className="text-xs text-foreground-500 font-body mt-1">
                Optimized at every layer
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 lg:max-w-[45%] flex items-stretch">
          <div className="relative w-full min-h-[420px] md:min-h-[520px] rounded-[32px] overflow-hidden" style={{ background: 'linear-gradient(160deg, oklch(0.82 0.01 240), oklch(0.72 0.015 80))' }}>
            <div className="absolute top-5 left-5 bg-background-50 text-foreground-900 text-xs font-medium uppercase tracking-wider px-4 py-2 rounded-full font-label">
              ZAGREB, CROATIA
            </div>
            <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-8 left-8 text-background-50">
              <p className="text-base font-medium font-body leading-relaxed">Ilica 322</p>
              <p className="text-sm text-background-50/80 font-body mt-1">10000 Zagreb</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}